// @ts-nocheck
import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
import * as Types from "../../__generated__/schema.graphql.types";

const defaultOptions = {} as const;
export type UpdateAppointmentCommunicationMutationVariables = Types.Exact<{
  appointmentId: Types.Scalars["bigint"]["input"];
  invoiceId: Types.Scalars["bigint"]["input"];
  sendBookingConfirmationSms?: Types.InputMaybe<
    Types.Scalars["Boolean"]["input"]
  >;
  sendBookingConfirmationMail?: Types.InputMaybe<
    Types.Scalars["Boolean"]["input"]
  >;
  sendConfirmationReminderSms?: Types.InputMaybe<
    Types.Scalars["Boolean"]["input"]
  >;
  sendConfirmationReminderMail?: Types.InputMaybe<
    Types.Scalars["Boolean"]["input"]
  >;
  sendSecondReminderSms?: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
  sendSecondReminderMail?: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
  sendAfterAppointmentNoteSms?: Types.InputMaybe<
    Types.Scalars["Boolean"]["input"]
  >;
  sendAfterAppointmentNoteMail?: Types.InputMaybe<
    Types.Scalars["Boolean"]["input"]
  >;
  sendFollowupNoteSms?: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
  sendFollowupNoteMail?: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
  sendCheckInReminderSms?: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
  sendCheckInReminderMail?: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
  sendAfterPaymentReceiptSms?: Types.InputMaybe<
    Types.Scalars["Boolean"]["input"]
  >;
  sendAfterPaymentReceiptMail?: Types.InputMaybe<
    Types.Scalars["Boolean"]["input"]
  >;
}>;

export type UpdateAppointmentCommunicationMutation = {
  __typename?: "mutation_root";
  updateAppointmentConfig?: {
    __typename?: "AppointmentConfigMutationResponse";
    affectedRows: number;
  } | null;
  updateInvoiceByPk?: {
    __typename?: "invoice";
    id: string;
    sendAfterPaymentReceiptSms?: boolean | null;
    sendAfterPaymentReceiptMail?: boolean | null;
  } | null;
};

export type CreateAppointmentCommunicationConfigMutationVariables =
  Types.Exact<{
    appointmentId: Types.Scalars["bigint"]["input"];
    invoiceId: Types.Scalars["bigint"]["input"];
    sendBookingConfirmationSms?: Types.InputMaybe<
      Types.Scalars["Boolean"]["input"]
    >;
    sendBookingConfirmationMail?: Types.InputMaybe<
      Types.Scalars["Boolean"]["input"]
    >;
    sendConfirmationReminderSms?: Types.InputMaybe<
      Types.Scalars["Boolean"]["input"]
    >;
    sendConfirmationReminderMail?: Types.InputMaybe<
      Types.Scalars["Boolean"]["input"]
    >;
    sendSecondReminderSms?: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
    sendSecondReminderMail?: Types.InputMaybe<
      Types.Scalars["Boolean"]["input"]
    >;
    sendAfterAppointmentNoteSms?: Types.InputMaybe<
      Types.Scalars["Boolean"]["input"]
    >;
    sendAfterAppointmentNoteMail?: Types.InputMaybe<
      Types.Scalars["Boolean"]["input"]
    >;
    sendFollowupNoteSms?: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
    sendFollowupNoteMail?: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
    sendCheckInReminderSms?: Types.InputMaybe<
      Types.Scalars["Boolean"]["input"]
    >;
    sendCheckInReminderMail?: Types.InputMaybe<
      Types.Scalars["Boolean"]["input"]
    >;
    sendAfterPaymentReceiptSms?: Types.InputMaybe<
      Types.Scalars["Boolean"]["input"]
    >;
    sendAfterPaymentReceiptMail?: Types.InputMaybe<
      Types.Scalars["Boolean"]["input"]
    >;
  }>;

export type CreateAppointmentCommunicationConfigMutation = {
  __typename?: "mutation_root";
  insertAppointmentConfigOne?: {
    __typename?: "AppointmentConfig";
    id: string;
    appointmentId: string;
    sendBookingConfirmationSms?: boolean | null;
    sendBookingConfirmationMail?: boolean | null;
    sendConfirmationReminderSms?: boolean | null;
    sendConfirmationReminderMail?: boolean | null;
    sendSecondReminderSms?: boolean | null;
    sendSecondReminderMail?: boolean | null;
    sendAfterAppointmentNoteSms?: boolean | null;
    sendAfterAppointmentNoteMail?: boolean | null;
    sendFollowupNoteSms?: boolean | null;
    sendFollowupNoteMail?: boolean | null;
    sendCheckInReminderSms?: boolean | null;
    sendCheckInReminderMail?: boolean | null;
  } | null;
  updateInvoiceByPk?: {
    __typename?: "invoice";
    id: string;
    sendAfterPaymentReceiptSms?: boolean | null;
    sendAfterPaymentReceiptMail?: boolean | null;
  } | null;
};

export const UpdateAppointmentCommunicationDocument = gql`
  mutation UpdateAppointmentCommunication(
    $appointmentId: bigint!
    $invoiceId: bigint!
    $sendBookingConfirmationSms: Boolean
    $sendBookingConfirmationMail: Boolean
    $sendConfirmationReminderSms: Boolean
    $sendConfirmationReminderMail: Boolean
    $sendSecondReminderSms: Boolean
    $sendSecondReminderMail: Boolean
    $sendAfterAppointmentNoteSms: Boolean
    $sendAfterAppointmentNoteMail: Boolean
    $sendFollowupNoteSms: Boolean
    $sendFollowupNoteMail: Boolean
    $sendCheckInReminderSms: Boolean
    $sendCheckInReminderMail: Boolean
    $sendAfterPaymentReceiptSms: Boolean
    $sendAfterPaymentReceiptMail: Boolean
  ) {
    updateAppointmentConfig(
      where: { appointmentId: { _eq: $appointmentId } }
      _set: {
        sendBookingConfirmationSms: $sendBookingConfirmationSms
        sendBookingConfirmationMail: $sendBookingConfirmationMail
        sendConfirmationReminderSms: $sendConfirmationReminderSms
        sendConfirmationReminderMail: $sendConfirmationReminderMail
        sendSecondReminderSms: $sendSecondReminderSms
        sendSecondReminderMail: $sendSecondReminderMail
        sendAfterAppointmentNoteSms: $sendAfterAppointmentNoteSms
        sendAfterAppointmentNoteMail: $sendAfterAppointmentNoteMail
        sendFollowupNoteSms: $sendFollowupNoteSms
        sendFollowupNoteMail: $sendFollowupNoteMail
        sendCheckInReminderSms: $sendCheckInReminderSms
        sendCheckInReminderMail: $sendCheckInReminderMail
      }
    ) {
      affectedRows
    }
    updateInvoiceByPk(
      pkColumns: { id: $invoiceId }
      _set: {
        sendAfterPaymentReceiptSms: $sendAfterPaymentReceiptSms
        sendAfterPaymentReceiptMail: $sendAfterPaymentReceiptMail
      }
    ) {
      id
      sendAfterPaymentReceiptSms
      sendAfterPaymentReceiptMail
    }
  }
`;
export type UpdateAppointmentCommunicationMutationFn = Apollo.MutationFunction<
  UpdateAppointmentCommunicationMutation,
  UpdateAppointmentCommunicationMutationVariables
>;

/**
 * __useUpdateAppointmentCommunicationMutation__
 *
 * To run a mutation, you first call `useUpdateAppointmentCommunicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppointmentCommunicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAppointmentCommunicationMutation, { data, loading, error }] = useUpdateAppointmentCommunicationMutation({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *      invoiceId: // value for 'invoiceId'
 *      sendBookingConfirmationSms: // value for 'sendBookingConfirmationSms'
 *      sendBookingConfirmationMail: // value for 'sendBookingConfirmationMail'
 *      sendConfirmationReminderSms: // value for 'sendConfirmationReminderSms'
 *      sendConfirmationReminderMail: // value for 'sendConfirmationReminderMail'
 *      sendSecondReminderSms: // value for 'sendSecondReminderSms'
 *      sendSecondReminderMail: // value for 'sendSecondReminderMail'
 *      sendAfterAppointmentNoteSms: // value for 'sendAfterAppointmentNoteSms'
 *      sendAfterAppointmentNoteMail: // value for 'sendAfterAppointmentNoteMail'
 *      sendFollowupNoteSms: // value for 'sendFollowupNoteSms'
 *      sendFollowupNoteMail: // value for 'sendFollowupNoteMail'
 *      sendCheckInReminderSms: // value for 'sendCheckInReminderSms'
 *      sendCheckInReminderMail: // value for 'sendCheckInReminderMail'
 *      sendAfterPaymentReceiptSms: // value for 'sendAfterPaymentReceiptSms'
 *      sendAfterPaymentReceiptMail: // value for 'sendAfterPaymentReceiptMail'
 *   },
 * });
 */
export function useUpdateAppointmentCommunicationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAppointmentCommunicationMutation,
    UpdateAppointmentCommunicationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateAppointmentCommunicationMutation,
    UpdateAppointmentCommunicationMutationVariables
  >(UpdateAppointmentCommunicationDocument, options);
}
export type UpdateAppointmentCommunicationMutationHookResult = ReturnType<
  typeof useUpdateAppointmentCommunicationMutation
>;
export type UpdateAppointmentCommunicationMutationResult =
  Apollo.MutationResult<UpdateAppointmentCommunicationMutation>;
export type UpdateAppointmentCommunicationMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateAppointmentCommunicationMutation,
    UpdateAppointmentCommunicationMutationVariables
  >;
export const CreateAppointmentCommunicationConfigDocument = gql`
  mutation CreateAppointmentCommunicationConfig(
    $appointmentId: bigint!
    $invoiceId: bigint!
    $sendBookingConfirmationSms: Boolean
    $sendBookingConfirmationMail: Boolean
    $sendConfirmationReminderSms: Boolean
    $sendConfirmationReminderMail: Boolean
    $sendSecondReminderSms: Boolean
    $sendSecondReminderMail: Boolean
    $sendAfterAppointmentNoteSms: Boolean
    $sendAfterAppointmentNoteMail: Boolean
    $sendFollowupNoteSms: Boolean
    $sendFollowupNoteMail: Boolean
    $sendCheckInReminderSms: Boolean
    $sendCheckInReminderMail: Boolean
    $sendAfterPaymentReceiptSms: Boolean
    $sendAfterPaymentReceiptMail: Boolean
  ) {
    insertAppointmentConfigOne(
      object: {
        appointmentId: $appointmentId
        sendBookingConfirmationSms: $sendBookingConfirmationSms
        sendBookingConfirmationMail: $sendBookingConfirmationMail
        sendConfirmationReminderSms: $sendConfirmationReminderSms
        sendConfirmationReminderMail: $sendConfirmationReminderMail
        sendSecondReminderSms: $sendSecondReminderSms
        sendSecondReminderMail: $sendSecondReminderMail
        sendAfterAppointmentNoteSms: $sendAfterAppointmentNoteSms
        sendAfterAppointmentNoteMail: $sendAfterAppointmentNoteMail
        sendFollowupNoteSms: $sendFollowupNoteSms
        sendFollowupNoteMail: $sendFollowupNoteMail
        sendCheckInReminderSms: $sendCheckInReminderSms
        sendCheckInReminderMail: $sendCheckInReminderMail
      }
    ) {
      id
      appointmentId
      sendBookingConfirmationSms
      sendBookingConfirmationMail
      sendConfirmationReminderSms
      sendConfirmationReminderMail
      sendSecondReminderSms
      sendSecondReminderMail
      sendAfterAppointmentNoteSms
      sendAfterAppointmentNoteMail
      sendFollowupNoteSms
      sendFollowupNoteMail
      sendCheckInReminderSms
      sendCheckInReminderMail
    }
    updateInvoiceByPk(
      pkColumns: { id: $invoiceId }
      _set: {
        sendAfterPaymentReceiptSms: $sendAfterPaymentReceiptSms
        sendAfterPaymentReceiptMail: $sendAfterPaymentReceiptMail
      }
    ) {
      id
      sendAfterPaymentReceiptSms
      sendAfterPaymentReceiptMail
    }
  }
`;
export type CreateAppointmentCommunicationConfigMutationFn =
  Apollo.MutationFunction<
    CreateAppointmentCommunicationConfigMutation,
    CreateAppointmentCommunicationConfigMutationVariables
  >;

/**
 * __useCreateAppointmentCommunicationConfigMutation__
 *
 * To run a mutation, you first call `useCreateAppointmentCommunicationConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppointmentCommunicationConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAppointmentCommunicationConfigMutation, { data, loading, error }] = useCreateAppointmentCommunicationConfigMutation({
 *   variables: {
 *      appointmentId: // value for 'appointmentId'
 *      invoiceId: // value for 'invoiceId'
 *      sendBookingConfirmationSms: // value for 'sendBookingConfirmationSms'
 *      sendBookingConfirmationMail: // value for 'sendBookingConfirmationMail'
 *      sendConfirmationReminderSms: // value for 'sendConfirmationReminderSms'
 *      sendConfirmationReminderMail: // value for 'sendConfirmationReminderMail'
 *      sendSecondReminderSms: // value for 'sendSecondReminderSms'
 *      sendSecondReminderMail: // value for 'sendSecondReminderMail'
 *      sendAfterAppointmentNoteSms: // value for 'sendAfterAppointmentNoteSms'
 *      sendAfterAppointmentNoteMail: // value for 'sendAfterAppointmentNoteMail'
 *      sendFollowupNoteSms: // value for 'sendFollowupNoteSms'
 *      sendFollowupNoteMail: // value for 'sendFollowupNoteMail'
 *      sendCheckInReminderSms: // value for 'sendCheckInReminderSms'
 *      sendCheckInReminderMail: // value for 'sendCheckInReminderMail'
 *      sendAfterPaymentReceiptSms: // value for 'sendAfterPaymentReceiptSms'
 *      sendAfterPaymentReceiptMail: // value for 'sendAfterPaymentReceiptMail'
 *   },
 * });
 */
export function useCreateAppointmentCommunicationConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAppointmentCommunicationConfigMutation,
    CreateAppointmentCommunicationConfigMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateAppointmentCommunicationConfigMutation,
    CreateAppointmentCommunicationConfigMutationVariables
  >(CreateAppointmentCommunicationConfigDocument, options);
}
export type CreateAppointmentCommunicationConfigMutationHookResult = ReturnType<
  typeof useCreateAppointmentCommunicationConfigMutation
>;
export type CreateAppointmentCommunicationConfigMutationResult =
  Apollo.MutationResult<CreateAppointmentCommunicationConfigMutation>;
export type CreateAppointmentCommunicationConfigMutationOptions =
  Apollo.BaseMutationOptions<
    CreateAppointmentCommunicationConfigMutation,
    CreateAppointmentCommunicationConfigMutationVariables
  >;
